'use strict';

angular.module('app.addUserToAccount', [])
	.controller('addUserToAccountCtrl', ['$scope', '$modal', '$modalInstance', 'addUserToAccountService',
		function ($scope, $modal, $modalInstance, addUserToAccountService){
		    
		    $scope.searchString = null;
		    $scope.selectedUserId = null;

		    $scope.preLoadData = function(){
		    	addUserToAccountService.getCompanyAndUser(false)
		    		.then(function(responseCompanyAndUser) {
		    			$scope.companies = responseCompanyAndUser.data;
		                $scope.renderCompany();
		    		}, function(responseCompanyAndUser) {
		    			var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = responseCompanyAndUser.message;
		    		})
		    }

		    $scope.preLoadData();

		    $scope.renderCompany = function(){
		        $scope.selectedCompanyId = $scope.companies[0].id;
		        $scope.companies[0].ticked = true;
		    }

		    $scope.searchCompanies = function() {
		        if($scope.searchString == null || $scope.searchString === undefined || $scope.searchString == ''){
		            $scope.inputSearch = 'All';
		        }else{
		            $scope.inputSearch = $scope.searchString;
		            // $scope.searchString = null;
		        }
		        
		        addUserToAccountService.searchCompanyByName($scope.inputSearch, false)
		        	.then(function(responseSearchCompanyByName) {
		        		$scope.companies = responseSearchCompanyByName.data;
		                $scope.renderCompany();
		        	}, function(responseSearchCompanyByName) {
		        		var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = responseSearchCompanyByName.message;
		        	})
		    }

		    $scope.closeModal = function () {
		        $scope.modalInstance.close();
		    }

		    $scope.save = function(){
		        $scope.companies.forEach(function (val) {
		            if (val.ticked === true) {
		                $scope.selectedCompanyId = val.id;
		            }    
		        });
		        $scope.selectedUserId = $scope.user_id;

		        var params ={
		            companyId:  $scope.selectedCompanyId,
		            userId:     $scope.selectedUserId
		        }

		        addUserToAccountService.addUserToAccount(params, true)
		        	.then(function(responseAddUserToCompany) {
		        		location.reload('admin/userAndBillingOverview');
		        	}, function(responseAddUserToCompany) {
		        		var modalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/admin/partials/user_company_name_doesnot_exist.html?app_v=deployDate',
		                    controller: 'billingPopupCtrl'
		                });
		                $scope.message = responseAddUserToCompany.message;
		                $scope.modalInstance = modalInstance;
		        	})
		    }

		    $scope.keyDownScrollCompany = function($event){
		        $scope.keyDownCharCode = $event.keyCode;

		        // angular.forEach not support break function hence using for loop
		        for(var i = 0; i < $('.filterOptions').length; i++){
		            var isCompanyElement = false;
		            var tempElements = $('.filterOptions')[i];

		            if(tempElements.firstElementChild.id != null && tempElements.firstElementChild.id !== undefined && tempElements.firstElementChild.id == ("selectCompany")){
		                isCompanyElement = true;
		            }

		            if(isCompanyElement){
		                var tempCompanies = tempElements.firstElementChild.lastElementChild.firstElementChild;
		                for(var k = 0; k < tempCompanies.length; k++){
		                    var companyItem = tempCompanies[k];
		                    var elementCharcode = companyItem.nextElementSibling.firstChild.data.charCodeAt(1);
		                    if($scope.keyDownCharCode == elementCharcode){
		                        var top = companyItem.parentElement.parentElement.parentElement.offsetTop;
		                        var parent = companyItem.parentElement.parentElement.parentElement.parentElement;
		                        parent.scrollTop = top;
		                        break;
		                        
		                    }
		                }
		            }
		        }
		    }

}])

.controller('billingPopupCtrl', ['$scope', '$rootScope', '$http' , '$modal', function ($scope, $modal, $http, $rootScope, localStorageService, $modalInstance){
    $scope.closeModal = function() {
        $modalInstance.close();
    }
}])